const estadoTexto = (vm, row) => {
    const base = {
        P: "PENDIENTE",
        B: "REVISAR/ANULAR",
        R: "REVISAR",
        C: "CANCELADA",
        I: "ANULADA",
        X: "PRUEBAS"
    };

    if (row.estado === "A") {
        let estado = "EMITIDA";

        if (row.documento_id === vm.GLOBAL.DOCUMENTO.PREFORMA) {
            const minutos = (new Date() - new Date(row.fecha)) / 60000;
            estado = minutos >= 5 ? "REVISAR" : "EN PROCESO...";
        }

        return estado;
    }

    if (row.estado === "G")
        return row.public_hasp == null ? "PENDIENTE" : "EMITIDA";

    return base[row.estado] ?? row.estado;
};

const estadoRenderer = vm => (data, type, row) => estadoTexto(vm, row);

export { estadoRenderer, estadoTexto };